import React from 'react';
import { Heading } from '..';
import css from '../../containers/ListingPage/ListingPage.module.css';
import { TbVaccine } from 'react-icons/tb';

const SectionVaccinations = props => {
  const { heading, selectedOptions = [],options=[], } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

    const optionLabelMap = options.reduce((acc, opt) => {
    acc[opt.key] = opt.label;
    return acc;
  }, {});
  const customHeading="Vaccinations Required to Board Pet"
  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {customHeading}
      </Heading>
      <ul className={css.cleaningFacilitiesList}>
        {selectedOptions.map(option => (
          <li key={option} className={css.multiEnumItem}>
            <span className={css.facilityIcon}><TbVaccine size={20}  style={{fill: 'none' }}/></span>
            <span>{optionLabelMap[option] || option}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SectionVaccinations;
